import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter as Router } from "react-router-dom";
import { Provider as StateProvider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";

import * as serviceWorker from "./serviceWorker";
import { getStore, setStore } from "./services/store";
import { setConfig } from "./utilities/config";
import App from "./app";
import bootstrap from "./boot";

import "ui/themes/styles.scss";

setConfig();
setStore();

const AppContainer = () => {
  return (
    <GoogleOAuthProvider clientId="960478194919-s0m6c5lpgf3vbrbb8u27asjusso18bal.apps.googleusercontent.com">
      <StateProvider store={getStore()}>
        <Router>
          <App />
        </Router>
      </StateProvider>
    </GoogleOAuthProvider>
  );
};

ReactDOM.render(<AppContainer />, document.getElementById("root"));

bootstrap();

serviceWorker.unregister();
